var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoProductAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 1C0.72 1 0 1.72 0 2.6V4.2H16V2.6C16 2.17565 15.8314 1.76869 15.5314 1.46863C15.2313 1.16857 14.8243 1 14.4 1H1.6ZM15.2 5H0.8V15.4C0.8 15.8243 0.968571 16.2313 1.26863 16.5314C1.56869 16.8314 1.97565 17 2.4 17H10.5351C10.1948 16.4117 10 15.7286 10 15C10 12.7909 11.7909 11 14 11C14.4181 11 14.8212 11.0641 15.2 11.1831V5ZM5.6 8.2V6.6H10.4V8.2H5.6Z",
    fill: "url(#paint0_linear_6341_18631)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 14.85C11.25 14.6567 11.4067 14.5 11.6 14.5H16.4C16.5933 14.5 16.75 14.6567 16.75 14.85C16.75 15.0433 16.5933 15.2 16.4 15.2H11.6C11.4067 15.2 11.25 15.0433 11.25 14.85Z",
    fill: "url(#paint1_linear_6341_18631)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.15 12.3C14.3433 12.3 14.5 12.4567 14.5 12.65L14.5 17.45C14.5 17.6433 14.3433 17.8 14.15 17.8C13.9567 17.8 13.8 17.6433 13.8 17.45L13.8 12.65C13.8 12.4567 13.9567 12.3 14.15 12.3Z",
    fill: "url(#paint2_linear_6341_18631)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6341_18631",
    x1: 0.571637,
    y1: 4,
    x2: 11.6131,
    y2: 15.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22918B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6341_18631",
    x1: 11.4465,
    y1: 14.6313,
    x2: 11.5632,
    y2: 15.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22918B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6341_18631",
    x1: 14.3687,
    y1: 12.4965,
    x2: 13.4162,
    y2: 12.6132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22918B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProductAdd);
export default __webpack_public_path__ + "static/media/ico-product-add.08eaf00cc54678f5224cfcb91f850178.svg";
export { ForwardRef as ReactComponent };